const register = {
    register_token: null,
    async searchBusiness() {
        const is_eu = document.getElementById('country').value.split('|')[1];
        const country = document.getElementById("country").value.split('|')[0];
        const taxCode = document.getElementById("tax_number").value;
        const euTaxCode = document.getElementById("eu_tax_number").value;

        if(country.length < 1 || (taxCode.length < 1 && country == 1) || (euTaxCode.length < 1 && is_eu == 1 && country != 1)){
            return;
        }

        if(country == 1){
            document.getElementById("tax_number_div").getElementsByClassName('loading-spin')[0].classList.remove('d-none');
        }else{
            document.getElementById("eu_tax_number_div").getElementsByClassName('loading-spin')[0].classList.remove('d-none');
        }

        document.getElementById("company_prefill_details").innerHTML = "";

        const response = await fetch(`/api/v1/lookup`, {
            method: "POST",
            headers: http.headers(),
            body: JSON.stringify({
                country_id: country,
                tax_code: taxCode,
                eu_tax_code: euTaxCode,
            })
        })

        const data = await response.json();
        if(country == 1){
            document.getElementById("tax_number_div").getElementsByClassName('loading-spin')[0].classList.add('d-none');
        }else{
            document.getElementById("eu_tax_number_div").getElementsByClassName('loading-spin')[0].classList.add('d-none');
        }

        if(data?.name?.length > 0) {
            document.getElementById("company_prefill_details").innerHTML = `
                <div>
                    <span>Cégnév:</span>
                    <span>${data.name}</span>
                </div>
                 <div>
                    <span>Cím:</span>
                    <span>${data.city} ${data.address}</span>
                </div>`;
        }
     },
    // while a request runs the button shows the spinner (loading-spin hides its label) and cannot be pressed again
    busy(button, on) {
        if (!button) {
            return;
        }
        button.disabled = on;
        button.classList.toggle('loading-spin', on);
    },
    showError(id, text) {
        const box = document.getElementById(id);
        box.textContent = text ?? '';
        box.hidden = !text;
    },
    // an error under the field it belongs to (the id of the input); an empty text clears it
    fieldError(id, text) {
        const field = document.getElementById(id);
        const group = field?.closest('.input-group');
        if (!group) {
            return;
        }
        const boxId = id + '_error';
        let box = document.getElementById(boxId);
        if (!box) {
            box = document.createElement('p');
            box.id = boxId;
            box.className = 'input-error';
            box.setAttribute('role', 'alert');
            group.appendChild(box);
        }
        box.textContent = text ?? '';
        box.hidden = !text;
        group.classList.toggle('has-error', !!text);
        field.setAttribute('aria-invalid', text ? 'true' : 'false');
        field.setAttribute('aria-describedby', boxId);
    },
    clearFieldErrors(ids) {
        ids.forEach((id) => this.fieldError(id, ''));
    },
    // shows the errors ({id: text}) and puts the cursor in the first wrong field; true when there were none
    check(errors) {
        const ids = Object.keys(errors);
        ids.forEach((id) => this.fieldError(id, errors[id]));
        const first = ids.find((id) => errors[id]);
        if (first) {
            document.getElementById(first).focus();
        }
        return !first;
    },
    isVisible(id) {
        const el = document.getElementById(id);
        return !!el && el.offsetParent !== null;
    },
    validatePersonal() {
        const email = document.getElementById('email').value.trim();

        return this.check({
            lastname: document.getElementById('lastname').value.trim().length < 2 ? 'Adja meg a vezetéknevét (legalább 2 karakter).' : '',
            firstname: document.getElementById('firstname').value.trim().length < 2 ? 'Adja meg a keresztnevét (legalább 2 karakter).' : '',
            email: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email) ? '' : 'Adjon meg egy érvényes e-mail címet.',
            privacy: document.getElementById('privacy').checked ? '' : 'A folytatáshoz el kell fogadnia a feltételeket.',
        });
    },
    validateCompany() {
        const errors = {};
        const taxId = this.isVisible('eu_tax_number') ? 'eu_tax_number' : 'tax_number';
        errors[taxId] = document.getElementById(taxId).value.trim() ? '' : 'Adja meg a cég adószámát.';
        errors.url_prefix = /^[a-z0-9]+(-[a-z0-9]+)*$/.test(document.getElementById('url_prefix').value) && document.getElementById('url_prefix').value.length >= 3
            ? '' : 'Legalább 3 karakter, csak kisbetű, szám és kötőjel (nem az elején vagy a végén).';
        if (this.isVisible('company_name')) {
            [['company_name', 'a cég nevét'], ['company_post_code', 'az irányítószámot'], ['company_city', 'a várost'], ['company_address', 'a címet']].forEach(([id, what]) => {
                errors[id] = document.getElementById(id).value.trim() ? '' : 'Adja meg ' + what + '.';
            });
        }

        return this.check(errors);
    },
    // whether the prefix is free and allowed: the server's answer, '' when it is
    async prefixProblem(prefix) {
        try {
            const response = await fetch('/api/v1/check-prefix', {
                method: 'POST',
                headers: http.headers(),
                body: JSON.stringify({ prefix: prefix, locale: 'hu' })
            });
            const data = await response.json();

            return data?.available === false ? (data.message ?? 'Ez a prefix nem használható.') : '';
        } catch (e) {
            // a failed check does not stop the sign-up: the creation checks it again
            return '';
        }
    },
    async checkPrefixField() {
        const prefix = document.getElementById('url_prefix').value;
        if (!/^[a-z0-9]+(-[a-z0-9]+)*$/.test(prefix) || prefix.length < 3) {
            return;
        }
        const problem = await this.prefixProblem(prefix);
        if (document.getElementById('url_prefix').value === prefix) {
            this.fieldError('url_prefix', problem);
        }
    },
    // the "Next" of the company step
    async toUsage(button) {
        if (!this.validateCompany()) {
            return;
        }
        this.busy(button, true);
        const problem = await this.prefixProblem(document.getElementById('url_prefix').value);
        this.busy(button, false);
        if (problem) {
            this.check({ url_prefix: problem });
            return;
        }
        this.showStep(3);
    },
    // what to tell the person about a refused answer: the reasons they can act on, else a plain line
    reason(response, data) {
        if (data?.errors?.register_token) {
            return 'A regisztráció lejárt vagy érvénytelen, kérjük, kezdje elölről az első lépéstől.';
        }
        if (data?.message === 'Missing business data') {
            return 'Hiányoznak a cég adatai (név, irányítószám, város, cím), kérjük, térjen vissza és egészítse ki őket.';
        }
        const first = Object.values(data?.errors ?? {})[0]?.[0];
        if (response && response.status < 500 && first) {
            return first;
        }
        return 'Valami hiba történt, kérjük, próbálja újra néhány perc múlva.';
    },
    async register(button) {
        const firstName = document.getElementById("firstname").value;
        const lastName = document.getElementById("lastname").value;
        const email = document.getElementById("email").value;

        this.showError('step1_error', '');
        if (!this.validatePersonal()) {
            return;
        }

        this.busy(button, true);
        try {
            const response = await fetch(`/api/v1/register`, {
                method: "POST",
                headers: http.headers(),
                body: JSON.stringify({
                    first_name: firstName,
                    last_name: lastName,
                    email: email,
                })
            })

            const data = await response.json();

            if(data?.register_token?.length > 0) {
                register.register_token = data?.register_token;
                register.email = email;
                this.showStep(2);
                return;
            }
            const fields = { first_name: 'firstname', last_name: 'lastname', email: 'email' };
            const refused = Object.keys(fields).filter((key) => data?.errors?.[key]);
            if (response.status === 422 && refused.length) {
                this.check(Object.fromEntries(refused.map((key) => [fields[key], 'Ez az adat nem fogadható el, kérjük, ellenőrizze.'])));
                return;
            }
            this.showError('step1_error', this.reason(response, data));
        } catch (e) {
            this.showError('step1_error', this.reason(null, null));
        } finally {
            this.busy(button, false);
        }
    },
    async create(button) {
        const is_eu = document.getElementById('country').value.split('|')[1];
        const country = document.getElementById("country").value.split('|')[0];
        const taxCode = document.getElementById("tax_number").value;
        const euTaxCode = document.getElementById("eu_tax_number").value;
        const prefix = document.getElementById("url_prefix").value;
        const city = document.getElementById("company_city").value;
        const postCode = document.getElementById("company_post_code").value;
        const address = document.getElementById("company_address").value;
        const businessName = document.getElementById("company_name").value;
        const businessType = document.getElementById("team").checked ? 1 : 2;
        const isWebshop = document.getElementById("webshops").checked ? 1 : 0;
        const isMarketspace = document.getElementById("marketspace").checked ? 1 : 0;
        const isPos = document.getElementById("pos").checked ? 1 : 0;
        const isManufacturing = document.getElementById("manufacturing").checked ? 1 : 0;
        const productCategory = document.querySelector('input[name="product_category"]:checked')?.value ?? '';


        this.showError('create_error', '');
        this.showError('url_prefix_error', '');
        this.busy(button, true);
        try {
            const response = await fetch(`/api/v1/create`, {
                method: "POST",
                headers: http.headers(),
                body: JSON.stringify({
                    register_token: register.register_token,
                    country_id: country,
                    tax_code: taxCode,
                    eu_tax_code: euTaxCode,
                    prefix: prefix,
                    city: city,
                    post_code: postCode,
                    address: address,
                    business_name: businessName,
                    business_type: businessType,
                    is_webshop: isWebshop,
                    is_marketspace: isMarketspace,
                    is_pos: isPos,
                    is_manufacturing: isManufacturing,
                    product_category: productCategory,
                    locale: 'hu',
                })
            });

            const data = await response.json();

            // the prefix is the one field the server can refuse for a reason the person can fix: show it where it is typed
            if (data?.errors?.prefix?.[0]) {
                this.showStep(2);
                this.check({ url_prefix: data.errors.prefix[0] });
                return;
            }

            // the tax number or the company data the server could not use: back to the step they are typed in
            const taxId = this.isVisible('eu_tax_number') ? 'eu_tax_number' : 'tax_number';
            if (data?.errors?.tax_code || data?.errors?.eu_tax_code) {
                this.showStep(2);
                this.check({ [taxId]: 'Adja meg a cég adószámát.' });
                return;
            }
            if (data?.message === 'Missing business data') {
                this.showStep(2);
                if (this.isVisible('company_name')) {
                    this.check({ company_name: 'Hiányoznak a cég adatai (név, irányítószám, város, cím), kérjük, egészítse ki őket.' });
                } else {
                    this.check({ [taxId]: 'Ehhez az adószámhoz nem találtunk céget, kérjük, ellenőrizze.' });
                }
                return;
            }

            if (!response.ok) {
                this.showError('create_error', this.reason(response, data));
                return;
            }

            document.getElementById('created_email').textContent = register.email ?? '';
            document.getElementById('created_address').textContent = 'https://' + prefix + document.getElementById('url_prefix_suffix').textContent;
            this.showStep(5);
        } catch (e) {
            this.showError('create_error', this.reason(null, null));
        } finally {
            this.busy(button, false);
        }
    },
    // the progress above the form: where the person is and the four segments
    stepNames: ['Személyes adatok', 'Cégadatok', 'Használat', 'Szolgáltatások'],
    showStep(step){
        for (let n = 1; n <= 5; n++) {
            document.getElementById('step' + n + '-form').style.display = n === step ? 'block' : 'none';
        }
        const progress = document.getElementById('register_progress');
        progress.hidden = step > 4;
        document.getElementById('progress_label').textContent = step + '. lépés a 4-ből · ' + (this.stepNames[step - 1] ?? '');
        progress.querySelectorAll('.register-progress-bars span').forEach((bar, i) => bar.classList.toggle('is-done', i < step));
    },
     handleCountryChange() {
         const is_eu = document.getElementById('country').value.split('|')[1];
         const country = document.getElementById('country').value.split('|')[0];
         const taxNumberDiv = document.getElementById('tax_number_div');
         const EuTaxNumberDiv = document.getElementById('eu_tax_number_div');
         const companyDetails = document.getElementById('company_details');

         console.log("country"+country);
         console.log("is_eu"+is_eu);

         if (country == 1) {
            taxNumberDiv.style.display = 'block';
            EuTaxNumberDiv.style.display = 'none';
            companyDetails.style.display = 'none';
            register.searchBusiness();
        } else if (is_eu == 1) {
            taxNumberDiv.style.display = 'none';
            EuTaxNumberDiv.style.display = 'block';
            companyDetails.style.display = 'none';
            register.searchBusiness();
        } else {
            taxNumberDiv.style.display = 'block';
            EuTaxNumberDiv.style.display = 'none';
            companyDetails.style.display = 'block';
        }
    }
};
// a field's error goes away as soon as the person edits it
document.addEventListener('input', (event) => {
    if (event.target?.getAttribute?.('aria-invalid') === 'true') {
        register.fieldError(event.target.id, '');
    }
});
document.addEventListener('change', (event) => {
    if (event.target?.getAttribute?.('aria-invalid') === 'true') {
        register.fieldError(event.target.id, '');
    }
});
window.register = register;
